export const URL_CONFIG = {
    "mi_url": "https://mi.toolup.cn", // 正式服务器
    // "mi_url": "http://toolup.cn:18080", // 灰度正式服务器
    // "mi_url": "http://192.168.3.4:8081",  //局域网下研发个人服务器
    // "mi_url": "http://127.0.0.1:8081", // 个人服务器
    "oss_url": "https://oss.toolup.cn",

    "translation_url": "http://toolup.cn:9999",

    "sample_url": "http://toolup.cn:60666",
}

export const VERSION_CONFIG = {
    "url_version": 2.0
}

export const PROMPT_CONFIG = {
    "prompt_version": 2.0
}


export const OSS_BUCKET = "ai-mi"